export const JOB_STAGES = {
  NEW_JOB: 'new job',
  JOB_STAGED: 'job staged',
  EQUIPMENT_SHIPPED: 'equipment shipped',
  OPERATOR_DISPATCHED: 'operator dispatched',
  OPERATOR_RETURNED: 'operator returned',
  EQUIPMENT_RETURNED: 'equipment returned',
  EQUIPMENT_RETURN: 'equip returned'
} as const;

export const STAGE_ORDER = [
  JOB_STAGES.NEW_JOB,
  JOB_STAGES.JOB_STAGED,
  JOB_STAGES.EQUIPMENT_SHIPPED,
  JOB_STAGES.OPERATOR_DISPATCHED,
  JOB_STAGES.OPERATOR_RETURNED,
  JOB_STAGES.EQUIPMENT_RETURNED
];

export const STAGE_MAP: { [key: string]: string } = {
  'New Job': 'new job',
  'Job Staged': 'job staged',
  'Equipment Shipped': 'equip shipped',
  'Operator Dispatched': 'operator dispatched',
  'Operator Returned': 'operator returned',
  'Equipment Returned': 'equip returned'
};
